import moment from "moment"

export const returnMomentLocale = (language: string) => {
  switch (language) {
    case "no":
      // Norwegian moment representation is nb
      return "nb"
    default:
      return language
  }
}

export const setMomentLocale = (language: string) => {
  const locale = returnMomentLocale(language)
  moment.locale(locale)
}
